<template>
  <div class="testpaper">
    <div class="header">
      <div class="contain header_wrap">
        <div class="icon">
          <img src="../../assets/icons/icon.png" alt>
        </div>
        <div class="title">
          {{message.examtitle}}
          <div class="record">
            得分:{{message.ehscore}}分
            <span style="margin-right:20px"></span>
            考试用时：{{time}}分钟
          </div>
        </div>
        <div class="back" @click="$router.go(-1)">返回</div>
      </div>
    </div>
    <div style="height:0.8rem;"></div>
    <div class="main contain_main">
      <div class="titlewarp">
        <div v-for="(item,order) in list" :key="'itemcheck'+order">
          <div v-show="item.questionsed.length">
            <div class="title">{{item.title}}</div>
            <div class="isright">
              <showright
                v-show="item.show"
                v-for=" (item,order) in item.questionsed"
                :type="(!item.usermes)||(Number(item.usermes.esscore)!=0)"
                :key="item.questionsid"
                :order="order+1"
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="button" style="float:right" @click="errorshow">{{show?"显示全部":"显示错题"}}</div>
        <div style="clear:both"></div>
      </div>
      <div class="questionwarp">
        <div v-for="(bitem,order) in list" :key="'item'+order">
          <div v-show="bitem.questionsed.length">
            <div class="title">
              {{bitem.title}}
              <!-- <span>（共4题，20分）</span> -->
            </div>
            <div>
              <issue
                v-for="(item,order) in bitem.questionsed"
                :key="'item'+order"
                :total="bitem.questionsed.length"
                :order="(order+1)"
                :message="item"
                :disabled='true' 
                v-show="item.show"
                :showasw="true"
              ></issue>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import issue from "../../components/issue";
import showright from "../../components/showright";
import { ExamHistory_getInfo2 } from "../../assets/js/api.js";
export default {
  name: "recordpaper",
  data() {
    return {
      list: [{questionsed:[]}],
      data:[],
      show: true,
      message: {
        epscore: "",
        examtitle: ""
      },
      time: 0
    };
  },
  mounted() {
    this.ehid = this.$route.query.id;
    this.getlist();
  },
  components: {
    issue,
    showright
  },
  methods: {
    errorshow() {
      if (!this.show) {
        this.list = this.data.map(item => {
          item.questionsed = item.questions.filter(sitem => {
            return !(
              !sitem.usermes || Number(sitem.usermes.esscore) != 0
            )
          });
          return item;
        });
        this.show = true;
      } else {
        this.list = this.data.map(item => {
          item.questionsed = item.questions.filter(sitem => {
            sitem.show = true;
            return true
          });
          return item;
        });
        this.show = false;
      }
      // console.log(this.data)
    },
    getlist() {
      ExamHistory_getInfo2({ ehid: this.ehid }).then(res => {
        if (res.data.code == 200) {
          var map = new Map();
          res.data.data.ehscorelist.forEach(item => {
            map.set(item.esquestionid - 0, item);
          });
          // 针对试题的检测，如果是多大题
          if (!res.data.data.ehquestion[0].title) {
            this.data = [
              {
                title: "试题",
                questions: res.data.data.ehquestion.map(item => {
                  if(item.questiontype==0){
                    return item
                  }
                  var t= map.get(Number(item.questionid-0))
                  t.questionanswer = item.questionanswer
                  item.usermes = t ;
                  item.questionanswer = t.esuseranswer
                  item.show = true;
                  return item;
                })
              }
            ];
          } else {
            this.data = res.data.data.ehquestion.map(item => {
              item.questions = item.questions.map(sitem => {
                var t= map.get(Number(sitem.questionid))
                t.questionanswer = sitem.questionanswer
                sitem.usermes = t ;
                sitem.questionanswer = t.esuseranswer
                sitem.show = true;
                return sitem;
              });
              return item;
            });
          }
          // // 有答案得情况
          // if (res.data.data.ehuseranswer) {
          //   // 试卷与试卷答案合并
          //   var map = new Map();
          //   res.data.data.ehuseranswer.forEach(item => {
          //     map.set(item.questionid - 0, item.questionanswer);
          //   });
          //   this.data  = this.data.map(item => {
          //     item.questions = item.questions.map(quest => {
          //       quest.questionanswer = map.get(quest.questionid - 0);
          //       return quest;
          //     });
          //     return item;
          //   });
          // }
          this.errorshow()
          this.time = Math.ceil(
            (res.data.data.ehendtime - res.data.data.ehstartime) / 60
          );
          this.message = res.data.data.ehsetting;
          this.message.ehscore = res.data.data.ehscore;
        }else {
          this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        }
      });
    }
  }
};
</script>
<style lang="css" scoped>
.header {
  width: 100%;
  height: 0.8rem;
  border: 1px solid #e8e9ee;
  position: fixed;
  top: 0;
  background: #fff;
  z-index: 1000;
}

.header_wrap {
  display: flex;
  justify-content: space-between;
  line-height: 0.75rem;
  background: #fff;
}
.record {
  position: absolute;
  bottom: 0.1rem;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.12rem;
  line-height: 0.2;
  width: 100%;
  color: #333;
}
.header_wrap .title {
  font-size: 0.26rem;
  color: #474dff;
  position: relative;
}
.header_wrap .back {
  width: 1.1rem;
  height: 0.3rem;
  border-radius: 0.03rem;
  color: #fff;
  background: #5b61ff;
  font-size: 0.16rem;
  display: inline-block;
  line-height: 0.3rem;
  margin-top: 0.22rem;
}
.button {
  width: 1.2rem;
  height: 0.3rem;
  border-radius: 0.03rem;
  color: #fff;
  background: #5b61ff;
  font-size: 0.16rem;
  display: inline-block;
  line-height: 0.3rem;
}
.main .titlewarp {
  margin-top: 0.4rem;
}
.main .questionwarp {
  margin-top: 0.4rem;
}
.main .title {
  font-size: 0.24rem;
  text-align: left;
}
.isright {
  text-align: left;
  padding: 0.1rem 0;
}
.header .title {
  width: 500px;
}
.title span {
  font-size: 0.16rem;
  color: "#777f90";
}
</style>


// WEBPACK FOOTER //
// src/pages/records/Recordpaper.vue